import { invalidate, addEffect, applyProps } from 'react-three-fiber';
import { FrameLoop, Globals } from '@react-spring/core';
export * from '@react-spring/core';
import { createHost } from '@react-spring/animated';
import { createStringInterpolator } from '@react-spring/shared/stringInterpolation';
import colorNames from '@react-spring/shared/colors';
import * as THREE from 'three';
var primitives = ['primitive'].concat(Object.keys(THREE).filter(function (key) {
  return /^[A-Z]/.test(key);
}).map(function (key) {
  return key[0].toLowerCase() + key.slice(1);
})); // Let r3f drive the frameloop.

var frameLoop = new FrameLoop(function () {
  return invalidate();
});
addEffect(function () {
  frameLoop.advance();
  return true; // Never stop.
});
Globals.assign({
  createStringInterpolator: createStringInterpolator,
  colorNames: colorNames,
  frameLoop: frameLoop
});
var host = createHost(primitives, {
  applyAnimatedValues: applyProps
});
var animated = host.animated;
export { animated as a, animated };